//请自行添加语言资源
const orderReceiptLog = {
  serialNo: '流水号',
  orderNo: '客户订单',
  imageUrl: '回单文件',
  dealStatus: '处理状态',
  dealCount: '处理次数',
  dealTime: '处理时间',
  dealResult: '处理结果',
  createTime: '创建时间',
  msg: {}
};
export default orderReceiptLog



// WEBPACK FOOTER //
// ./src/page/log/mdlzsct/orderReceiptLog/lang/orderReceiptLog.zh.js